import {
  combineReducers,
  createStore,
  applyMiddleware,
  compose,
} from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import * as reducers from '../../redux/reducers/index';
import { LOGOUT } from '../../redux/actions/loginActions';
import authMiddleware from '../../redux/middleware/authMiddleware';

const rootReducer = (state, action) => {
  const newState = action.type === LOGOUT
    ? {
      theme: state.theme,
      sidebar: state.sidebar,
      rtl: state.rtl,
    } : state;
  return combineReducers(reducers)(newState, action);
};

// Conditionally use composeWithDevTools based on environment
const composeEnhancers = process.env.NODE_ENV !== 'production'
  ? composeWithDevTools({}) // Use DevTools in development
  : compose; // Use standard compose in production

const store = createStore(
  rootReducer,
  {},
  composeEnhancers(applyMiddleware(thunk, authMiddleware)),
  // composeEnhancers(applyMiddleware(thunk)),
);

export default store;
